export default __webpack_public_path__ + "static/media/sessions_tg_search_ru.1c2c3c9f.jpg";